<template>
  <el-dialog
  class="ModalRename"
  title="Rename"
  :show-close="false"
  :visible="visible"
  :before-close="handleClose"
  @open="onOpen"
  @opened="onOpened">
    <el-input
    ref="renameInput"
    :placeholder="fileName"
    v-model="temporaryName"
    class="ModalRename__input"/>
    <span
    slot="footer"
    class="ModalRename__footer">
      <el-button
      type="text"
      @click="handleClose">
        Cancel
      </el-button>
      <el-button
      :disabled="!validateName"
      type="primary"
      @click="renameFile">
        Rename
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ModalRename',

  data () {
    return {
      temporaryName: '',
      fileExtension: ''
    }
  },

  computed: {
    ...mapGetters('modal', [
      'visibleByModal',
      'fileByModal'
    ]),
    file () {
      return this.fileByModal('rename')
    },
    visible () {
      return this.visibleByModal('rename')
    },
    fileName () {
      return this.file ? this.file.name : ''
    },
    validateName () {
      return this.nameNotEmpty && this.nameCharactersValid
    },
    nameNotEmpty () {
      return this.temporaryName.trim().length
    },
    nameCharactersValid () {
      const invalidCharacters = ['/', '\\', '|', '<', '>', ':', '"', '?', '*']
      let index = invalidCharacters.findIndex(char => {
        return this.temporaryName.includes(char)
      })
      return index === -1
    }
  },

  methods: {
    ...mapActions('modal', [
      'hideModal'
    ]),
    ...mapActions('files', [
      'updateFile'
    ]),
    ...mapActions('filesFolder', [
      'updateFolder'
    ]),
    handleClose () {
      this.hideModal('rename')
      this.resetState()
    },
    renameFile () {
      this.temporaryName = this.temporaryName.trim()
      let nameWithExtansion = `${this.temporaryName}.${this.fileExtension}`

      if (this.file.type === 5) {
        const payload = {
          fileId: this.file.id,
          name: this.temporaryName
        }
        this.updateFolder(payload)
      } else {
        const payload = {
          fileId: this.file.id,
          name: nameWithExtansion,
          size: this.file.size
        }
        this.updateFile(payload)
      }
      this.resetState()
    },
    onOpen () {
      if (this.file.type !== 5) {
        let tempFileName = this.fileName.split('.')
        this.fileExtension = tempFileName.pop()
        this.temporaryName = tempFileName.join('.')
      } else {
        this.temporaryName = this.fileName
      }
    },
    onOpened () {
      if (this.$refs.renameInput) this.$refs.renameInput.focus()
    },
    resetState () {
      this.fileExtension = ''
      this.temporaryName = ''
    }
  }
}
</script>

<style lang="scss">
@import 'ModalRename';
</style>
